'use strict';

const defaultConfig = {
  navigateIfCurrent: {
    type: 'boolean',
    value: false
  },
  autoInitialBootstrap: {
    type: 'boolean',
    value: true
  },
  scrollToTopOnBootstrap: {
    type: 'boolean',
    value: false
  }
}

function getConfig(suppliedConfig) {
  for (let c in defaultConfig) {
    if ((typeof suppliedConfig[c] === 'undefined') ||
        (typeof suppliedConfig[c] !== defaultConfig[c].type)) {
          suppliedConfig[c] = defaultConfig[c].value;
    }
  }
  return suppliedConfig;
}

module.exports = {
  getConfig
}



// WEBPACK FOOTER //
// ../autor/src/config.js